import type { QueryClient } from '@tanstack/react-query';

// Every react-query key for the backend session data lives under one root so
// a single cascade can drop all of it: any account mutation (linking,
// passkeys, sessions, profile, sign-out) can change what several of these
// answer, and the backend exposes no finer change signal.
export const ssoKeys = {
  all: ['sso'] as const,
  config: ['sso', 'config'] as const,
  clientName: (clientId: string) => ['sso', 'client-name', clientId] as const,
  me: (authuser: number | undefined) => ['sso', 'me', authuser] as const,
  accounts: (authuser: number | undefined) =>
    ['sso', 'accounts', authuser] as const,
  links: (authuser: number | undefined) => ['sso', 'links', authuser] as const,
  passkeys: (authuser: number | undefined) =>
    ['sso', 'passkeys', authuser] as const,
  sessions: (authuser: number | undefined) =>
    ['sso', 'sessions', authuser] as const,
  connectedApps: (authuser: number | undefined) =>
    ['sso', 'connected-apps', authuser] as const,
  sessionInfo: (
    expectedSessionId: string | null,
    authuser: number | undefined,
  ) => ['sso', 'session-info', expectedSessionId, authuser] as const,
  consentInfo: (query: string) => ['sso', 'consent-info', query] as const,
  magicLinkCheck: (token: string) =>
    ['sso', 'magic-link-check', token] as const,
};

export function invalidateSso(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: ssoKeys.all });
}
